import { Crown } from 'lucide-react';
import { PhotoIdentite } from '../PhotoIdentite';

const PLACES = {
  1: { marche: 'h-28 sm:h-36', photo: 'w-20 h-20 sm:w-28 sm:h-28', couleur: '#F5B301', texte: 'text-amber-950' },
  2: { marche: 'h-20 sm:h-28', photo: 'w-16 h-16 sm:w-24 sm:h-24', couleur: '#CBD5E1', texte: 'text-slate-800' },
  3: { marche: 'h-16 sm:h-20', photo: 'w-16 h-16 sm:w-24 sm:h-24', couleur: '#CD7F32', texte: 'text-orange-950' },
};

// Une marche du podium : photo, nom, nombre de notes et moyenne
export const PodiumMarche = ({ stagiaire, rang, delai }) => {
  const p = PLACES[rang];
  const initiales = `${stagiaire?.prenom?.[0] || ''}${stagiaire?.nom?.[0] || ''}`.toUpperCase();
  return (
    <div className="podium-rise flex flex-col items-center flex-1 min-w-0 max-w-[220px]" style={{ animationDelay: `${delai}ms` }} data-testid={`podium-place-${rang}`}>
      {stagiaire ? (
        <>
          <Crown className={`h-6 w-6 mb-1 ${rang === 1 ? 'text-amber-400' : 'invisible'}`} />
          <div className={`${p.photo} rounded-full overflow-hidden bg-slate-700 shadow-lg`} style={{ boxShadow: `0 0 0 4px ${p.couleur}, 0 10px 25px -5px rgba(0,0,0,.5)` }}>
            <PhotoIdentite
              userId={stagiaire.user_id}
              alt={`${stagiaire.prenom} ${stagiaire.nom}`}
              className="w-full h-full object-cover"
              testId={`podium-photo-${rang}`}
              fallback={<div className="w-full h-full flex items-center justify-center text-xl font-bold text-white">{initiales}</div>}
            />
          </div>
          <p className="mt-3 w-full text-center text-sm sm:text-base font-semibold text-white truncate" title={`${stagiaire.prenom} ${stagiaire.nom}`} data-testid={`podium-nom-${rang}`}>
            {stagiaire.prenom} {stagiaire.nom?.toUpperCase()}
          </p>
          <p className="text-xs text-slate-400">{stagiaire.nb_notes} notes</p>
        </>
      ) : (
        <div className={`${p.photo} mt-7 rounded-full border-2 border-dashed border-slate-600`} />
      )}
      <div className={`mt-3 w-full ${p.marche} rounded-t-xl flex flex-col items-center pt-2`} style={{ backgroundColor: p.couleur }}>
        <span className={`text-2xl sm:text-3xl font-display font-extrabold leading-none ${p.texte}`}>{rang}</span>
        {stagiaire && (
          <span className={`mt-1 text-xs sm:text-sm font-bold ${p.texte}`} data-testid={`podium-moyenne-${rang}`}>
            {stagiaire.moyenne.toFixed(1)}/10
          </span>
        )}
      </div>
    </div>
  );
};
